//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { _q } from '@/util/util'
export default {
  props: ['Items', 'title', 'target', 'type', 'index', 'parm'],
  data () {
    return {
      selectIndex: {id: '', idx: 0, target: 0},
      value: ''
    }
  },
  components: {},
  created () {
  },
  mounted () {
    this.selectIndex.id = this.index
    if (this.target) {
      this.selectIndex.target = this.target
    }
    if (this.Items.length > 0) {
      this.selectIndex.idx = this.Items[0].oid
      // console.log(this.selectIndex.idx)
      this.value = this.Items[0].name
    }
  },
  computed: {
    selectIdx () {
      return this.selectIndex
    }
  },
  watch: {
    'selectIdx.idx' (val) {
      this.$emit('on-result-change', this.selectIndex, this.parm)
    },
    'Items' (val) {
      if (this.Items.length > 0) {
        this.selectIndex.idx = this.Items[0].oid
        // console.log(this.selectIndex.idx)
        this.value = this.Items[0].name
      }
    }
  },
  methods: {
    sltChange (e) {
      let self = e.target
      let index = self.selectedIndex
      let _text = self.options[index].text
      this.value = _text
      _q('input', self.parentNode.parentNode).value = _text
      this.selectIndex.idx = self.options[index].value
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Select.vue